<template>
  <div v-if="pillBarPills.length > 0">
    <div
      v-if="resultCount > 0"
      :class="{
        'mb-6 flex flex-col gap-2 lg:flex-row': true,
      }"
    >
      <span
        :class="{
          'mr-14 whitespace-nowrap': true,
        }"
        >Showing {{ resultCount }} results for
      </span>
      <div
        :class="{
          'flex flex-wrap gap-2': true,
        }"
      >
        <span
          v-for="pill in pillBarPills"
          :key="pill.id"
          :class="{
            'w-fit rounded-[100px] border border-www-color-neutral-very-light bg-www-color-white py-2 pl-1 pr-5 text-xs': true,
          }"
          data-component-name="filterPill"
        >
          <span
            :class="{
              'p-2': true,
            }"
            >{{ pill.label }}
          </span>
          <button
            :class="{
              'text-18px text-www-color-neutral-light': true,
            }"
            @click="
              emitChange({ id: pill.id, isChecked: false, forceScroll: true, slug: pill.slug })
            "
          >
            &times;
          </button>
        </span>
      </div>
    </div>
    <div
      v-else
      :class="{
        'flex w-full flex-col items-center justify-center bg-www-color-white py-70px': true,
      }"
    >
      No results matched your criteria, try changing your filters.
      <div
        :class="{
          'flex flex-wrap gap-2': true,
        }"
      >
        <span
          v-for="pill in pillBarPills"
          :key="pill.id"
          :class="{
            'w-fit rounded-[100px] border border-www-color-neutral-very-light bg-www-color-white py-2 pl-1 pr-5 text-xs': true,
          }"
        >
          <span
            :class="{
              'p-2': true,
            }"
            >{{ pill.label }}
          </span>
          <button
            :class="{
              'text-18px text-www-color-neutral-light': true,
            }"
            @click="
              emitChange({ id: pill.id, isChecked: false, forceScroll: true, slug: pill.slug })
            "
          >
            &times;
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TaxonomyChangedPayload } from '~/composables/useContentFilter';

defineProps({
  pillBarPills: {
    type: Object as PropType<Array<TaxonomyPill>>,
    required: true,
  },
  resultCount: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits<{
  (_evt: 'taxonomyChange', _payload: TaxonomyChangedPayload): void;
}>();

const emitChange = (payload: TaxonomyChangedPayload) => {
  emit('taxonomyChange', payload);
};
</script>
